import axiosFlow from '@/services/axios/axiosFlow'

export default class GruposContatosService {
  static async get(nomeOuDescricao) {
    const params = new URLSearchParams()

    if (nomeOuDescricao) {
      params.append('NomeOuDescricao', nomeOuDescricao)
    }

    return axiosFlow.get(`grupos-contatos?${params}`).then(res => res.data.data)
  }

  static async post(body) {
    return axiosFlow.post('grupos-contatos', body).then(res => res.data.data)
  }

  static async put(gruposContatosId, body) {
    return axiosFlow.put(`grupos-contatos/${gruposContatosId}`, body).then(res => res.data.data)
  }
}
